const API_TOKEN = 'AIzaSyAPRdAgY8v9XxwZau6znv7TwgkJNKBq6zM'; // Убедитесь, что это ваш реальный API-ключ

export const loadGoogleScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    const existingScript = document.getElementById('googleMaps');
    if (existingScript) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_TOKEN}&libraries=places`;
    script.id = 'googleMaps';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    script.onload = () => {
      resolve();
    };

    script.onerror = error => {
      // eslint-disable-next-line no-console
      console.error('Failed to load Google Maps script:', error);
      reject(new Error('Google Maps script failed to load.'));
    };
  });
};
